import { supabase } from '../supabase'

export const auditRepository = {
  async logDuplicateAttempt(params: {
    existingPlayerId: number
    attemptedFullName: string
    attemptedMobileNumber: string
    attemptedSportIds: number[]
    attemptedSportNames: string[]
  }): Promise<void> {
    try {
      const changeDescription = JSON.stringify({
        attempted_name: params.attemptedFullName,
        attempted_mobile: params.attemptedMobileNumber,
        attempted_sport_ids: params.attemptedSportIds,
        attempted_sport_names: params.attemptedSportNames,
      })

      await supabase.from('player_changes').insert({
        player_id: params.existingPlayerId,
        changed_by: `${params.attemptedFullName} (${params.attemptedMobileNumber})`,
        change_type: 'duplicate_attempt',
        change_description: changeDescription,
      })
    } catch (error) {
      // Non-blocking - log to console but don't throw
      console.error('Failed to log duplicate attempt:', error)
    }
  },
}
